import { lazy } from "react";

const routes = [
  {
    path: "/pincode",
    element: lazy(() => import("../pages/PinCode")),
  },
  {
    path: "/pincode/add",
    element: lazy(() => import("../pages/PinCode/create")),
  },
  {
    path: "/pincode/edit/:id",
    element: lazy(() => import("../pages/PinCode/edit")),
  },
];

export default routes;
